import styled from 'styled-components';
import { pxToRem, vars } from '$util/theme';

export const Styled = styled.small`
  font-size: ${pxToRem(13)};
  text-align: center;
  color: ${vars.quantumverse.reskinColors.neutral400};
  margin-bottom: 5px;
`;
